import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6 text-xl font-medium"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "text-3xl font-medium" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = {
  href: "https://playincluded.com/privacy-policy",
  target: "_blank",
  class: "text-link"
}
const _hoisted_6 = { class: "flex items-start mt-6 space-x-3" }
const _hoisted_7 = {
  href: "https://playincluded.com/data",
  target: "_blank",
  class: "text-link"
}
const _hoisted_8 = { class: "flex items-start mt-6 space-x-3" }
const _hoisted_9 = { class: "flex justify-between mt-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_11 = {
  key: 2,
  class: ""
}
const _hoisted_12 = { class: "text-3xl font-medium" }
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = {
  href: "https://playincluded.com/data",
  target: "_blank",
  class: "text-link"
}
const _hoisted_15 = { class: "mt-6" }
const _hoisted_16 = { class: "text-3xl font-medium" }
const _hoisted_17 = { class: "mt-2 border rounded" }
const _hoisted_18 = { class: "flex justify-between mt-6" }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "text-3xl font-medium" }
const _hoisted_21 = { class: "mt-4" }
const _hoisted_22 = {
  href: "https://playincluded.com/data",
  target: "_blank",
  class: "text-link"
}
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "flex space-x-4" }
const _hoisted_25 = ["onUpdate:modelValue", "disabled"]
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "flex space-x-4" }
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = { class: "flex items-center" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "flex space-x-4" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex justify-between mt-6" }
const _hoisted_37 = { key: 4 }
const _hoisted_38 = { class: "text-3xl font-medium" }
const _hoisted_39 = { class: "mt-4" }
const _hoisted_40 = {
  href: "https://playincluded.com/privacy-policy",
  target: "_blank",
  class: "text-link"
}
const _hoisted_41 = { class: "mt-6" }
const _hoisted_42 = { class: "mt-2 border rounded" }
const _hoisted_43 = { class: "space-y-2.5 mt-4 mx-4" }
const _hoisted_44 = { class: "mt-4 text-lg font-medium" }
const _hoisted_45 = { class: "flex justify-between mt-6" }
const _hoisted_46 = {
  key: 5,
  class: "space-y-4"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-medium" }, "You have successfully added your child to their Brick Club.", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "" }, [
  /*#__PURE__*/_createTextVNode(" Please complete a short questionnaire about your child’s needs. This information is used by Play Included in an anonymised format to report on the impact of the Brick-by-Brick® programme. You can view out Play Included handle sensitive data "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://playincluded.com/data",
    target: "_blank",
    class: "text-link"
  }, "here"),
  /*#__PURE__*/_createTextVNode(" . The questionnaire will open in a new window. ")
], -1)
const _hoisted_49 = { class: "space-x-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/dashboard",
    class: "block h-10 px-3 py-2 font-normal text-white capitalize transition ease-in border rounded whitespace-nowrap focus:outline-none focus:shadow-outline-purple duration-50 w-fit bg-primary active:bg-blue-600 hover:bg-blue-600 border-primary"
  }, " Back to dashboard ")
], -1)

import { PropType, ref, onMounted } from "vue";

import DefaultButton from "./DefaultButton.vue";
import ListRowItem from "./ListRowItem.vue";
import TitleHeader from "./TitleHeader.vue";
import ExternalLink from "./ExternalLink.vue";
import AlertCard from "./AlertCard.vue";

import { Student, User } from "@/types";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store";
import { getSurveyUrl } from "@/utils/survey";


export default /*#__PURE__*/_defineComponent({
  __name: 'ParentOnboarding',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
  student: {
    type: Object as PropType<Student>,
    required: true,
  },
},
  emits: ["update", "finish"],
  setup(__props, { emit: emits }) {

const props = __props;




const editStudent = ref({} as Student);
const parents = ref();
const step = ref(1);

const { user } = storeToRefs(useUserStore());

function updateStudent() {
  emits("update", editStudent.value, parents.value, step.value);
}

async function getParents() {
  parents.value = editStudent.value.parents.map((p: any) => {
    return {
      id: p.id,
      name: `${p.first_name} ${p.last_name}`,
      email: p.email,
      is_primary: p.id === props.student.primary_parent,
    };
  });
  parents.value.sort((a: any, b: any) => b.is_primary - a.is_primary);
}

function removeParent(index: number) {
  if (index === 0) return;
  parents.value.splice(index, 1);
}

onMounted(async () => {
  editStudent.value = Object.assign({}, props.student);
  await getParents();
});

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (5 > step.value)
        ? (_openBlock(), _createBlock(TitleHeader, {
            key: 0,
            title: _ctx.$t('welcome')
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (5 === step.value)
        ? (_openBlock(), _createBlock(TitleHeader, {
            key: 1,
            title: _ctx.$t('thank-you-parent')
          }, null, 8, ["title"]))
        : _createCommentVNode("", true)
    ]),
    (5 > step.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("step-of-four", [step.value])), 1))
      : _createCommentVNode("", true),
    (step.value === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("permissions")), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("parent-onboarding-explainer-1")), 1),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("parent-onboarding-explainer-2")) + " ", 1),
              _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t("privacy-policy")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "mt-2 rounded",
              type: "radio",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editStudent.value.survey_permission) = $event)),
              value: true
            }, null, 512), [
              [_vModelRadio, editStudent.value.survey_permission]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("parent-onboarding-attendance-permission")) + " ", 1),
                _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t("what-does-this-mean")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              class: "mt-2 rounded",
              type: "radio",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editStudent.value.survey_permission) = $event)),
              value: false
            }, null, 512), [
              [_vModelRadio, editStudent.value.survey_permission]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t("parent-onboarding-no-permission")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(DefaultButton, {
              type: "primary",
              onAction: _cache[2] || (_cache[2] = ($event: any) => (step.value = 2))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("next")), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (step.value === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("parent-onboarding-started")), 1),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("parent-onboarding-started-text")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("parent-onboarding-started-text-2")), 1),
          _createVNode(_component_i18n_t, {
            keypath: "parent-onboarding-started-text-3",
            tag: "p",
            for: "here"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t("here")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t("child-details")), 1),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(ListRowItem, {
                title: _ctx.$t('first-name-initial')
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "name",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editStudent.value.first_name) = $event)),
                    placeholder: "Initial",
                    class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
                    maxlength: "3",
                    required: ""
                  }, null, 512), [
                    [_vModelText, editStudent.value.first_name]
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('middle-name-initial')
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "name",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editStudent.value.middle_name) = $event)),
                    placeholder: "Initial",
                    class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
                    maxlength: "3"
                  }, null, 512), [
                    [_vModelText, editStudent.value.middle_name]
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(ListRowItem, {
                title: _ctx.$t('family-name-initial')
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "name",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editStudent.value.last_name) = $event)),
                    placeholder: "Initial",
                    class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
                    maxlength: "3",
                    required: ""
                  }, null, 512), [
                    [_vModelText, editStudent.value.last_name]
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(DefaultButton, {
                type: "primary",
                onAction: _cache[6] || (_cache[6] = ($event: any) => (step.value = 1))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("back")), 1)
                ]),
                _: 1
              }),
              _createVNode(DefaultButton, {
                type: "primary",
                onAction: _cache[7] || (_cache[7] = ($event: any) => (step.value = 3))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("next")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (step.value === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.$t("parent-carer-details")), 1),
          _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("parent-carer-details-text")), 1),
          _createVNode(_component_i18n_t, {
            keypath: "parent-carer-details-text-2",
            tag: "p",
            for: "here"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.$t("here")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, [
            _createVNode(_component_i18n_t, {
              keypath: "parent-carer-details-text-3",
              tag: "p"
            }, {
              strong: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("“My Profile”")), 1)
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parents.value, (p, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mt-6 border border-gray-400 rounded",
              key: index
            }, [
              _createVNode(ListRowItem, {
                title: `${p.is_primary ? _ctx.$t('primary') : _ctx.$t('additional')} ${_ctx.$t('parent-carer')} - ${_ctx.$t('name')}`
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "name",
                    "onUpdate:modelValue": ($event: any) => ((parents.value[index].name) = $event),
                    placeholder: "Name",
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 8, _hoisted_23), [
                    [_vModelText, parents.value[index].name]
                  ])
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(ListRowItem, {
                title: `${p.is_primary ? _ctx.$t('primary') : _ctx.$t('additional')} ${_ctx.$t('parent-carer')} - ${_ctx.$t('email')}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "name",
                      "onUpdate:modelValue": ($event: any) => ((parents.value[index].email) = $event),
                      placeholder: "Email",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      required: "",
                      disabled: parents.value[index].email === _unref(user).email
                    }, null, 8, _hoisted_25), [
                      [_vModelText, parents.value[index].email]
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      (index !== 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "text-link",
                            type: "button",
                            onClick: ($event: any) => (removeParent(index))
                          }, _toDisplayString(_ctx.$t("remove")), 9, _hoisted_27))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["title"]),
              (p.is_primary)
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 0,
                    title: `${p.is_primary ? _ctx.$t('primary') : _ctx.$t('additional')} ${_ctx.$t('parent-carer')} - ${_ctx.$t('secondary-email')} (optional)`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "name",
                          "onUpdate:modelValue": ($event: any) => ((parents.value[index].secondary_email) = $event),
                          placeholder: "Secondary Email",
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                        }, null, 8, _hoisted_29), [
                          [_vModelText, parents.value[index].secondary_email]
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          (index !== 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "text-link",
                                type: "button",
                                onClick: ($event: any) => (removeParent(index))
                              }, _toDisplayString(_ctx.$t("remove")), 9, _hoisted_31))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                : _createCommentVNode("", true),
              (p.is_primary)
                ? (_openBlock(), _createBlock(ListRowItem, {
                    key: 1,
                    title: `${p.is_primary ? _ctx.$t('primary') : _ctx.$t('additional')} ${_ctx.$t('parent-carer')} - ${_ctx.$t('secondary-phone')} (optional)`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "name",
                          "onUpdate:modelValue": ($event: any) => ((parents.value[index].secondary_phone) = $event),
                          placeholder: "Secondary Phone",
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                        }, null, 8, _hoisted_33), [
                          [_vModelText, parents.value[index].secondary_phone]
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          (index !== 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "text-link",
                                type: "button",
                                onClick: ($event: any) => (removeParent(index))
                              }, _toDisplayString(_ctx.$t("remove")), 9, _hoisted_35))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(DefaultButton, {
              type: "primary",
              onAction: _cache[8] || (_cache[8] = ($event: any) => (step.value = 2))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("back")), 1)
              ]),
              _: 1
            }),
            _createVNode(DefaultButton, {
              type: "primary",
              onAction: _cache[9] || (_cache[9] = ($event: any) => (step.value = 4))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("next")), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (step.value === 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.$t("member-profile")), 1),
          _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("member-profile-text")), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("member-profile-text-2")), 1),
            _createElementVNode("a", _hoisted_40, _toDisplayString(_ctx.$t("privacy-policy")), 1),
            _createTextVNode(_toDisplayString(_ctx.$t("member-profile-text-3")), 1)
          ]),
          _createVNode(AlertCard, {
            type: "warning",
            class: "mt-6"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("medication-warning")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("additional-question")), 1),
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  name: "note",
                  id: "note",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editStudent.value.additional_notes) = $event)),
                  class: "text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-16 border-gray-400",
                  required: ""
                }, null, 512), [
                  [_vModelText, editStudent.value.additional_notes]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(DefaultButton, {
              type: "primary",
              onAction: _cache[11] || (_cache[11] = ($event: any) => (step.value = 3))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("back")), 1)
              ]),
              _: 1
            }),
            _createVNode(DefaultButton, {
              type: "primary",
              onAction: _cache[12] || (_cache[12] = ($event: any) => {
          step.value = 5;
          updateStudent();
        })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("next")), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (step.value === 5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _hoisted_47,
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, [
            _createVNode(ExternalLink, {
              href: _unref(getSurveyUrl)(_unref(user), __props.student, __props.student.clubs[0]),
              label: _ctx.$t('complete-background-survey'),
              type: "button"
            }, null, 8, ["href", "label"])
          ]),
          _hoisted_50
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})